import React from 'react';

import Card from '../Card';

import './style.scss';

class CardForm extends React.Component {
  render() {
    return (
      <Card>
        <div className="card__title">{this.props.title}</div>
        <div className="card__subtitle">{this.props.subtitle}</div>
        <div className="card__body">{this.props.children}</div>
      </Card>
    );
  }
}

export default CardForm;



// WEBPACK FOOTER //
// ./src/routes/assessment/components/CardForm/index.js